// src/components/navbar/Navbar.js
import React from "react";
import HeaderAdmin from "../header/Header";

export default function Navbar() {
  return (
    <div className="max-w-7xl mx-auto space-y-8 animate-fadeIn">
      {/* Title Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 border-b border-gray-200 pb-2">
        <div>
          <h2 className="text-3xl font-bold text-gray-800">Navigation & Headers</h2>
          <p className="text-gray-500 text-xs mt-0.5">Manage logo assets, hamburger icons, and top header navigation menus.</p>
        </div>
      </div>

      {/* Main Panel Content */}
      <div className="mt-8">
        <HeaderAdmin />
      </div>
    </div>
  );
}
